'use client'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs'
import { useEffect, useRef, useState } from 'react'

interface TabItem {
    value: string
    label: string
    content: React.ReactNode
}

interface TabSidebarProps {
    tabs: TabItem[]
    onEdit?: () => void
    onReset?: () => void
}

export function TabSidebar({ tabs, onEdit, onReset }: TabSidebarProps) {
    const [activeTab, setActiveTab] = useState(tabs[0]?.value || '')
    const [sliderStyle, setSliderStyle] = useState({})
    const tabsRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (tabsRef.current) {
            const activeTabElement = tabsRef.current.querySelector(
                `[data-state="active"]`
            ) as HTMLElement
            if (activeTabElement) {
                setSliderStyle({
                    left: activeTabElement.offsetLeft,
                    width: activeTabElement.offsetWidth,
                    transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                })
            }
        }
    }, [activeTab])

    return (
        <div className="flex flex-col h-full w-full">
            <Tabs value={activeTab} onValueChange={setActiveTab} className="flex flex-col flex-1 min-h-0 w-full relative">
                <div className="relative shrink-0" ref={tabsRef}>
                    <TabsList className={`grid bg-slate-800 dark:bg-slate-200 rounded-lg p-1 h-12 relative mt-2 mx-2`} style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}>
                        {tabs.map((tab) => (
                            <TabsTrigger
                                key={tab.value}
                                value={tab.value}
                                className="relative z-10 transition-colors duration-300 text-white data-[state=active]:text-slate-800"
                            >
                                {tab.label}
                            </TabsTrigger>
                        ))}
                        {/* Sliding indicator */}
                        <div
                            className="absolute top-1 h-10 bg-white dark:bg-gray-900 rounded-md shadow-sm z-0"
                            style={sliderStyle}
                        />
                    </TabsList>
                </div>

                {tabs.map((tab) => (
                    <TabsContent key={tab.value} value={tab.value} className="flex flex-col flex-1 min-h-0 px-2 pt-2 data-[state=inactive]:hidden">
                        {tab.content}
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    )
}
